import { useToast } from '@chakra-ui/react';
import {
  QuestionMetadataDto,
  UpsertQuestionMetadataDto,
} from '@keyops-cep/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { upsertQuestionMetadata } from '../api/question-metadata.functions';
import i18n from '../utils/i18n';

export const useUpdateQuestionMetadata = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation<
    QuestionMetadataDto,
    unknown,
    {
      newQuestionMetadata: UpsertQuestionMetadataDto;
      closeEditPanel?: () => void;
    }
  >({
    mutationFn: ({ newQuestionMetadata }) =>
      upsertQuestionMetadata(newQuestionMetadata),

    onSuccess: async (updatedQuestionMetadata, variables) => {
      if (updatedQuestionMetadata) {
        await queryClient.invalidateQueries({
          queryKey: [
            'engagementDetailsById',
            variables.newQuestionMetadata.engagementId,
          ],
        });

        toast({
          title: i18n.t('visualization.editPanel.successMessage'),
          variant: 'subtle',
          isClosable: true,
          status: 'success',
          position: 'top-right',
        });

        variables.closeEditPanel && variables.closeEditPanel();
      }
    },

    onError: (error) => {
      console.error(error);
      toast({
        title: i18n.t('errorComponent.title'),
        description: i18n.t('errorComponent.subTitle'),
        variant: 'subtle',
        isClosable: true,
        status: 'error',
        position: 'top-right',
      });
    },
  });
};
